export enum WarningStatusType {
  RequiredFields = 1,
  ErrorInTime,
  RequiredCustomData,
}

export const WarningStatusDetails = new Map<
  WarningStatusType,
  { text: string; icon: string; color: string }
>([
  [
    WarningStatusType.RequiredFields,
    {
      text: $localize`:@@dprDetails.warningStatusType.txtRequiredFields:Some required fields are not completed`,
      icon: 'alert',
      color: 'wip',
    },
  ],
  [
    WarningStatusType.ErrorInTime,
    {
      text: $localize`:@@dprDetails.warningStatusType.txtErrorInTime:Error in time`,
      icon: 'error-in-time',
      color: 'wip',
    },
  ],
  [
    WarningStatusType.RequiredCustomData,
    {
      text: $localize`:@@dprDetails.warningStatusType.txtRequiredCustomData:Some required custom data are not completed`,
      icon: 'clipboard-list-outline',
      color: 'wip',
    },
  ],
]);
